import C from 'utils/values/constant.util';

const TIME_OFF_DURATIONS = C({
  block: { id: 'block', description: 'Block time' },
  day: { id: 'day', description: 'All day' },
  // SEE: https://getslick.atlassian.net/browse/GS-11924
  longer: { id: 'longer', hide: true, description: 'Longer' },
});

export default TIME_OFF_DURATIONS;
